module.exports = __webpack_public_path__ + "static/img/9.9cf3b065.png";